import { Chip } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";

const VerifiedStatus = ({ status, isBtnVisible }) => {
  return (
    <Chip
      icon={
        status ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="8"
            height="8"
            viewBox="0 0 8 8"
            fill="none"
          >
            <circle cx="4" cy="4" r="3" fill="#17B26A" />
          </svg>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="8"
            height="8"
            viewBox="0 0 8 8"
            fill="none"
          >
            <circle cx="4" cy="4" r="3" fill="#F04438" />
          </svg>
        )
      }
      label={status ? "Verified" : "Unverified"}
      color={status ? "success" : "error"}
      size="small"
      sx={{
        fontWeight: 500,
        fontSize: "12px",
        height: "22px",
        borderRadius: "6px",
        bgcolor: status ? "#ECFDF3" : "#FEF3F2",
        color: status ? "#16A34A" : "#B42318",
        border: status ? "1px solid #ABEFC6" : "1px solid #FECDCA",
        // positioning
        position: "absolute",
        right: !isBtnVisible ? 10 : 93,
        top: "11.5px",
      }}
    />
  );
};

export default VerifiedStatus;

VerifiedStatus.propTypes = {
  status: PropTypes.any,
  isBtnVisible: PropTypes.bool,
};
